import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Routes as routes } from '../navigation';
import { UserActions, NavigationActions, ContextActions, ConsultationsActions, PracticeActions } from '../actions';
import { TitleBar, NavBar, LinkedPractices, PendingLinkRequests, LinkNewPractice, PracticeCreateNew, ProviderInvitesSection } from  '../components'

class MyAccountScreen extends Component {

  componentDidMount() {
    this.props.contextActions.fetchDataForScreenAndRole('myaccount');
  }

  renderContentContainers = () => {
    return <div className="flex-container screen-main-content">
        <div className="screen-container-column">
          <ProviderInvitesSection
            token={this.props.user.auth.token}
            userActions={this.props.userActions}
          />
          <LinkedPractices
            selectedPractice={this.props.context.selectedPractice}
            selectedRole={this.props.context.selectedRole}
            roles={this.props.user.roles}
            practices={this.props.user.practices}
            notifications={this.props.notifications}
            contextActions={this.props.contextActions}
          />
        </div>
        <div className="screen-container-column">
          <PracticeCreateNew
            token={this.props.user.auth.token}
            user={this.props.user.user}
            loading={this.props.loading}
            practiceActions={this.props.practiceActions}
          />
          <div className="standard-container" style={{ padding: 15, paddingTop: 10, paddingBottom: 10 }}>
            <div className="flex-container flex-container-row flex-space-between flex-center-align">
              <div>
                <span className='fas fa-sign-out-alt' style={{ color: '#1dc2ff', marginRight: 8, marginLeft: 2 }} />
                <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>Sign out of TeleTails</span>
              </div>
              <div>
                <input  type="submit"
                        value="Sign Out"
                        className="button-default"
                        onClick={ () => { this.props.userActions.signOut(); NavigationActions.navigateTo(routes.SIGN_IN) }}
                      />
              </div>
            </div>
          </div>
        </div>
      </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          hideCurrentInfo={true}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <NavBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          selectedTab={'my_account'}
          practice={this.props.practice.practice}
          currentRoute={routes.MY_ACCOUNT}
          notifications={this.props.notifications}
        />

        { this.renderContentContainers() }

      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
      { ...ContextActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountScreen)
